<script>

</script>

<style>
    .container {
        position: relative;
        display: flex;
        flex-flow: column nowrap;
        width: 100%;
    }

    .logo {
        font-weight: 700;
        margin-right: 20px;
        margin-top: 5px;
        margin-bottom: 5px;
        height: 20px;
        background-position: bottom right;
        background-size: contain;
        background-repeat:no-repeat;
        background-image: url('./../images/wordmark.svg');
    }

    footer {
        width: 100%;
        font-size: 12px;
        min-height: 30px;
        line-height: normal;
        padding: 8px 0;
        padding-right: 20px;
        text-align: right;
        background: #219EBC;
    }

    a:hover {
        text-decoration: underline;
    }

    .separator1 {
        margin-left: 20px;
        margin-right: 20px; 
    }

    .separator2 {
        display:initial;
        margin-left: 20px;
        margin-right: 20px;
    }

    .newLine {
        display: none;
    }

    @media (max-width: 600px) {
        .separator2 {
            display:none;
        }

        .newLine {
            display: initial;
        }
	}


</style>

<div class="container">
    <div class="logo" />
    <footer>
        <a class="footer-elem" href="#/legal/terms-and-conditions" target="_blank">Terms and Conditions</a>
        <span class="separator1">|</span>
        <a class="footer-elem" href="#/legal/privacy-policy" target="_blank">Privacy Policy</a>
        <span class="separator2">|</span><span class="newLine"><br/></span> 
        <span class="copyright">©2021-2024 httpiness contributors - All rights reserved.</span>
    </footer>
</div>
